import React from 'react';
import { localizedStrings } from 'src/localization/index.jsx';
import cx from 'classnames';
import styles from './styles.module.scss';
import _ from 'lodash';

class DataSourceMigrationStatusView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      completed: false,
      newAssets: 0
    } 

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedContentSources = this.localizedSettings.content_sources;
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.status && nextProps.status.completed){
      this.showSuccessMessage(nextProps);
    }
  }

  showSuccessMessage(nextProps) {
    this.setState({
      completed: true,
      migratedAssets: nextProps.status ? nextProps.status.migratedAssets : 0
    }, () => {
      this.props.invalidateMigrationStatus({id: this.props.datasource.id});
      this.props.fetchDataSource(false);

      setTimeout(() => {
        this.props.closeToast();
      }, 20000);
    })
  }

  render(){
    return (
      <div>
        {!this.state.completed && this._renderInProgress()}
        {this.state.completed && this._renderCompleted()}
      </div>
    );
  }

  _renderInProgress() {
    const name = _.get(this.props.datasource, 'name');
    const storageName = _.get(this.props.datasource, 'storageName');

    return (
      <div> 
        <div className={styles.description}>
          {localizedStrings.formatString(this.localizedContentSources.toast.migrating, {
            storageName: storageName,
            name: name
          })
          }
        </div>

        {this.props.status &&
          <ul className={styles.status}>
            <li>
              <div className={styles.value}>{this.props.status.migratedAssets}</div>
              <div className={styles.label}>{this.localizedContentSources.migrated_assets}</div>
            </li>
            <li>
              <div className={styles.value}>{this.props.status.existingAssets}</div>
              <div className={styles.label}>{this.localizedContentSources.existing_assets}</div>
            </li>
          </ul>
        }
      </div>
    )
  }

  _renderCompleted() {
    const name = _.get(this.props.datasource, 'name');
    const storageName = _.get(this.props.datasource, 'storageName');

    return (
      <div>
        <div className={styles.description}>
        {localizedStrings.formatString(this.localizedContentSources.toast.migration_success, {
          storageName: storageName,
          name: name
        })}
          {this.state.migratedAssets > 0 && localizedStrings.formatString(this.localizedContentSources.toast.migrated_assets, {
            migratedAssets: this.state.migratedAssets
          })}
        </div>
      </div>
    )
  }
}

export default DataSourceMigrationStatusView;